// Deployment Email Generation Prompts
export const DEPLOYMENT_EMAIL_TEMPLATES = {
  professional: (productName) => `You are a professional sales engineer at Turintech. Generate a formal business email for ${productName} deployment options.
Structure:
1. Professional greeting
2. Brief introduction to ${productName}
3. Simple markdown table comparing deployment options (NO cost column)
4. Key benefits and differentiators
5. SaaS options details (Shared vs Dedicated IP, resource allocation)
6. LLM integration capabilities and flexibility
7. Professional closing with next steps`,

  concise: (productName) => `You are a technical consultant at Turintech. Generate a brief, to-the-point email for ${productName} deployment options.
Structure:
1. Direct greeting
2. One-line intro
3. Simple comparison table (NO cost column)
4. 3 key points including SaaS IP options and LLM flexibility
5. Clear call to action`,

  technical: (productName) => `You are a solutions architect at Turintech. Generate a detailed technical email for ${productName} deployment options.
Structure:
1. Technical greeting
2. Technical overview of ${productName}
3. Detailed comparison table (NO cost column)
4. Technical deep-dive on:
   - SaaS architecture (shared vs dedicated IP addresses)
   - LLM integration options (cloud APIs, on-premise gateways, BYOL)
   - Security, scalability, and data privacy
5. Technical implementation roadmap`,

  markdown: (productName) => `Generate a clean markdown document for ${productName} deployment options.
Structure:
# ${productName} Deployment Options
## Overview
Brief description of ${productName}
## Deployment Comparison
Markdown table with deployment options
## Key Features
- Bullet points for each deployment option
## Next Steps
Clear action items`,

  rawmarkdown: (productName) => `Generate a pure markdown template for ${productName} deployment options documentation.
Include:
- Product overview
- Comprehensive deployment comparison table with all technical details
- SaaS architecture details (shared vs dedicated IPs)
- LLM integration options (cloud APIs, on-premise gateways, BYOL)
- Infrastructure requirements per deployment type
- Security and compliance features
- Data privacy and sovereignty options
- Integration capabilities
- Migration pathways

Use proper markdown formatting with headers, tables, lists, and code blocks where appropriate.`
};

// Product-specific details
export const PRODUCT_DETAILS = {
  evoml: {
    name: 'EvoML',
    description: 'our data science platform',
    fullDescription: 'EvoML is our comprehensive data science platform that empowers teams to build, train, and deploy ML models efficiently. It provides advanced AutoML capabilities, experiment tracking, and model management.'
  },
  artemis: {
    name: 'Artemis',
    description: 'our code optimization platform',
    fullDescription: 'Artemis is our intelligent code optimization platform that uses AI to analyze, optimize, and improve code quality, performance, and security. It helps development teams write better code faster.'
  }
};

// Additional context for prompts
export const LLM_DETAILS = `
Key LLM Capabilities:
- Bring Your Own LLM: Choose from OpenAI, AWS Bedrock, Azure OpenAI, Google Vertex AI, Anthropic, or any custom LLM
- No Training on Your Data: In SaaS deployments, all LLMs used do not train on customer data
- Flexible Integration: Add LLMs via API keys or integrate with your enterprise LLM gateways
- Cost Management: Use our LLMs with usage-based pricing or bring your own to manage costs directly
- POC Credits: We provide $50 in LLM credits to start your proof of concept
`;

export const SAAS_DETAILS = `
SaaS Deployment Details:
- Shared SaaS: Single cluster with encrypted, isolated customer data. Recommended for quick start and ease of use
- Dedicated SaaS: New cluster on dedicated IP with location-based access restrictions for enhanced privacy
- Both options ensure complete data isolation and encryption
`;

// Table formatting instructions
export const TABLE_INSTRUCTIONS = `
IMPORTANT: 
- Do NOT include any cost or pricing information in the email or table
- Keep the markdown simple and clean
- The table should have these exact columns: Deployment Type | Infrastructure | Setup Time | Security | Privacy | Internet | LLM Options
- Keep table cells concise but informative
- For Setup Time use: Instant, < 1 day, 1-2 days, 2-3 days, 1 week
- For Security use: Standard, Enhanced, High, Maximum
- For Privacy use: Limited, Medium, High, Maximum
- For Internet use: Yes, No, or Conditional
- For LLM Options use: Cloud APIs, Local Models, Hybrid, Custom Gateway
- Emphasize:
  - SaaS Shared: Multi-tenant with shared IP addresses, usage-based resources
  - SaaS Dedicated: Isolated instance with dedicated IP, guaranteed resources
  - Flexibility to bring your own LLM or integrate with on-premise LLM gateways
  - Support for all major cloud providers (AWS, Azure, Google Cloud) and custom integrations`;